import React, { useEffect } from 'react';

import { Button, Form, Input, Select, Popconfirm } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

import { cloneDeep } from 'lodash';

const { Option } = Select;

type PropsType = {
  enums?: any;
  value?: any;
}

const textStyle: React.CSSProperties = { display: 'inline-block', height: 32, lineHeight: '32px', padding: '0 12px' };

const DEGAULT_FIELDS = [
  { min_kilo: 0 },
  {  },
];

const SPStoreDistance: React.FC<PropsType> = (props) => {
  const { enums, value } = props;
  console.log(enums, '====');
  const { same_city_pr_car_distance_list, same_city_pr_car_fee_list } = enums || {};
  const form = Form.useFormInstance();

  const handleMaxDistanceChange = () => {
    const price = cloneDeep(form.getFieldValue('pay_conf'));
    price.forEach((item: any, index: number) => {
      if (price[index - 1]) {
        item.min_kilo = price[index - 1].max_kilo;
      }
    })
    console.log(price);
    form.setFieldValue('pay_conf', price);
  }

  const DistanceFormItem = (fields: any, field: any, index: number, remove: any) => (
    <>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          JSON.stringify(prevValues) !== JSON.stringify(curValues)
        }
      >
        {() => (
          <Form.Item
            label="门店间距离"
            name={[field.name, 'min_kilo']}
            rules={[{ required: true, message: '请选择距离' }]}
            style={{ display: 'inline-block' }}
          >
            <Select disabled style={{ width: 130 }}>
              {(same_city_pr_car_distance_list || []).map((item: any) => (
                <Option key={item.key} value={+item.value}>
                  {item.value}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
      </Form.Item>
      <div style={textStyle}>公里~</div>
      <Form.Item
        label=""
        name={[field.name, 'max_kilo']}
        rules={[{ required: true, message: '请选择距离' }]}
        style={{ display: 'inline-block' }}
      >
        <Select style={{ width: 130 }} onChange={handleMaxDistanceChange}>
          {(same_city_pr_car_distance_list || []).map((item: any) => (
            <Option key={item.key} value={+item.value}>
              {item.value}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <div style={textStyle}>公里（含）收取费用</div>
      <Form.Item
        label=""
        name={[field.name, 'fee']}
        rules={[{ required: true, message: '请选择费用' }]}
        style={{ display: 'inline-block' }}
      >
        <Select style={{ width: 130 }}>
          {(same_city_pr_car_fee_list || []).map((item: any) => (
            <Option key={item.key} value={+item.value}>
              {item.value}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <div style={textStyle}>元</div>
      {index > 0 && <Popconfirm
        title="确认删除吗?"
        onConfirm={() => {
          remove(field.name)
        }}
        okText="确认"
        cancelText="取消"
      >
        <Button danger>删除</Button>
      </Popconfirm>}
    </>
  );
  
  const EndFormItem = (fields: any, field: any, index: number, remove: any) => (
    <>
      <Form.Item noStyle>
        <Form.Item
          label="门店间距离"
          name={[field.name, 'min_kilo']}
          rules={[{ required: true, message: '请选择距离' }]}
          style={{ display: 'inline-block' }}
        >
          <Select disabled style={{ width: 130 }}>
            {(same_city_pr_car_distance_list || []).map((item: any) => (
              <Option key={item.key} value={+item.value}>
                {item.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <div style={textStyle}>公里以上收取费用</div>
        <Form.Item
          label=""
          name={[field.name, 'fee']}
          rules={[{ required: true, message: '请选择费用' }]}
          style={{ display: 'inline-block' }}
        >
          <Select disabled={0 < index && index < fields.length - 1 } style={{ width: 130 }}>
            {(same_city_pr_car_fee_list || []).map((item: any) => (
              <Option key={item.key} value={+item.value}>
                {item.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <div style={textStyle}>元</div>
      </Form.Item>
    </>
  );

  useEffect(() => {
    if (value?.length) {
      form.setFieldValue('pay_conf', value);
    } else {
      form.setFieldValue('pay_conf', DEGAULT_FIELDS);
    }
  }, [value]);

  return (
    <Form.List name="pay_conf" initialValue={DEGAULT_FIELDS}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => {
            return (
              <div key={field.key}>
                {index < fields.length - 1 && DistanceFormItem(fields, field, index, remove)}
                {index === fields.length - 1 && EndFormItem(fields, field, index, remove)}
              </div>
            )
          })}
          <Form.Item>
            <Button type="dashed" onClick={() => add({})} block icon={<PlusOutlined />}>
              添加
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  )
}

export default SPStoreDistance;